import { getCompositeSubmissionId } from '../../../Helpers/originId';
import { ClientApiRequestError } from './clientApiError.helpers';

const PROXY_PREFIX = '/proxy/outreach-api-integrations';

/** The named api operation of the step with that key, from the matched collection. */
export const getStepApi = ({ collection, stepKey, operation }) =>
  collection?.implementations?.[stepKey]?.api?.[operation];

/**
 * Calls one outreach step operation through the gateway proxy with an already
 * resolved dependency body, returning the whole `{ data, answers }` response.
 * `label` names the step in errors ("Store lookup", "Slot lookup", "Booking").
 */
export const fetchClientApiStep = async ({
  api,
  body,
  submissionId,
  token,
  label,
}) => {
  const url = `${process.env.NEXT_PUBLIC_CHAMELEON_GATEWAY_BASE_URL}${PROXY_PREFIX}${api.url}`;
  // The gateway checks the token against x-submission-id; Rhino's step contract
  // (strategies.md, "Invoking a step") reads x-unique-submission-id. Same value.
  const compositeSubmissionId = getCompositeSubmissionId(submissionId);
  const response = await fetch(url, {
    method: api.method,
    headers: {
      'Content-Type': 'application/json',
      'x-submission-id': compositeSubmissionId,
      'x-unique-submission-id': compositeSubmissionId,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  let payload;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    throw new ClientApiRequestError(
      `${label} failed with status ${response.status}`,
      response.status,
      payload
    );
  }
  if (payload?.errors?.length) {
    throw new ClientApiRequestError(
      `${label} returned an errors array`,
      null,
      payload
    );
  }
  if (payload?.data === undefined)
    throw new Error(`${label} returned an unexpected response shape`);
  return payload;
};
